import type {
  ServiceGetAllResponse,
  ServiceGetByIdResponse,
  ServiceMutationOptionType,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { FilterSubitemKepValues } from '../validation'
import type { AsetDataType } from './types'
import type { MutationAsetValues } from './validation'

const QUERY_KEY = (key?: string | Record<string, any>) =>
  ['kep-aset', key] as const

const getAll = (
  params?: FilterSubitemKepValues
): ServiceQueryOptionType<ServiceGetAllResponse<Array<AsetDataType>>> => ({
  queryKey: QUERY_KEY(params),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<Array<AsetDataType>>
      >(`/kelembagaan/kep/${params?.id_kep}/aset`, {
        params: {
          ...params,
          id_kep: undefined
        }
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const create = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<AsetDataType>,
  MutationAsetValues
> => ({
  mutationFn: async (data: MutationAsetValues) => {
    try {
      const response = await api.post<ServiceGetByIdResponse<AsetDataType>>(
        `/kelembagaan/kep/${data?.id_kep}/aset`,
        {
          ...data
        }
      )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const update = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<AsetDataType>,
  MutationAsetValues
> => ({
  mutationFn: async (data: MutationAsetValues) => {
    try {
      const response = await api.put<ServiceGetByIdResponse<AsetDataType>>(
        `/kelembagaan/kep/${data?.id_kep}/aset/${data.id_aset}`,
        {
          ...data
        }
      )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const deleteData = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<AsetDataType>,
  { id_kep: string; id_data: string }
> => ({
  mutationFn: async (data: { id_kep: string; id_data: string }) => {
    try {
      const response = await api.delete<ServiceGetByIdResponse<AsetDataType>>(
        `/kelembagaan/kep/${data?.id_kep}/aset/${data?.id_data}`
      )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const aset = {
  queryKey: [QUERY_KEY(undefined)[0]],
  getAll,
  create,
  update,
  deleteData
}
